import type { Action } from "../state/actions.ts";
import type { DrawObject, Point } from "../types/document.ts";

type ToolCall = { name: string; input: Record<string, unknown> };

export const applyTool = (tool: ToolCall): Action[] => {
  switch (tool.name) {
    case "set_text":
      return [{ type: "SET_TEXT_HTML", html: tool.input.html as string }];

    case "add_emoji":
      return [
        {
          type: "ADD_OBJECT",
          object: {
            type: "emoji",
            position: [tool.input.x as number, tool.input.y as number] as Point,
            emoji: tool.input.emoji as string,
            size: (tool.input.size as number) ?? 32,
          },
        },
      ];

    case "add_shape": {
      const { shape, x, y, width, height, color, strokeWidth, fill } = tool.input as Record<
        string,
        any
      >;
      const sw = strokeWidth ?? 2;
      const c = color ?? "#1a1a1a";
      const object: DrawObject =
        shape === "line"
          ? { type: "line", from: [x, y], to: [x + width, y + height], color: c, width: sw }
          : shape === "ellipse"
            ? {
                type: "ellipse",
                center: [x + width / 2, y + height / 2],
                radii: [width / 2, height / 2],
                color: c,
                width: sw,
                fill,
              }
            : { type: "rect", origin: [x, y], size: [width, height], color: c, width: sw, fill };
      return [{ type: "ADD_OBJECT", object }];
    }

    case "clear_decorations":
      return [{ type: "CLEAR_OBJECTS" }];

    default:
      return [];
  }
};
